import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginModal from '../components/LoginModal';
import SignupModal from '../components/SignupModal';

export default function AuthPage() {
  const [mode, setMode] = useState('login');
  const location = useLocation();
  const navigate = useNavigate();
  const destination =
    typeof location.state?.from === 'string'
      ? location.state.from
      : location.state?.from?.pathname || '/';
  const close = () => navigate(destination, { replace: true });

  return (
    <main className="min-h-screen bg-slate-950">
      <div className="mx-auto flex min-h-[70vh] max-w-4xl items-center justify-center px-4 text-center text-white">
        <div>
          <p className="text-5xl" aria-hidden>🏆</p>
          <h1 className="mt-4 text-3xl font-black">Welcome to WE R GAME</h1>
          <p className="mt-2 text-slate-400">Sign in to play FREE, BOOST and MARKET, earn Golden Tickets, and shop rewards.</p>
        </div>
      </div>
      {mode === 'login' ? (
        <LoginModal onClose={close} onSwitchToSignup={() => setMode('signup')} />
      ) : (
        <SignupModal onClose={close} onSwitchToLogin={() => setMode('login')} />
      )}
    </main>
  );
}
